import React from "react";
import { RouteProps } from "react-router-dom";
import { routeConstants } from "@/shared/constants";
import loadable from "@/shared/utils/loadable";

const RouteDetails = loadable(import("./index"));

const RouteDetailRoute: RouteProps = {
  path: routeConstants["route-details"].route,
  element: React.createElement(RouteDetails),
};

export default RouteDetailRoute;
